import { useState, useEffect } from "react";
import { SHOW_DEBUG_ITEMS_ENABLED } from "@/components/estimation-details/Rooms/ToggleShowDebugItems";

export const useShowDebugItems = () => {
  const [showDebugItems, setShowDebugItems] = useState(() => {
    const isFeatureEnabled = import.meta.env.VITE_SHOW_DEBUG_ITEMS === "true";
    const isToggleEnabled = localStorage.getItem(SHOW_DEBUG_ITEMS_ENABLED) === "true";
    return isFeatureEnabled && isToggleEnabled;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const isFeatureEnabled = import.meta.env.VITE_SHOW_DEBUG_ITEMS === "true";
      const isToggleEnabled = localStorage.getItem(SHOW_DEBUG_ITEMS_ENABLED) === "true";
      setShowDebugItems(isFeatureEnabled && isToggleEnabled);
    };

    // Listen for localStorage changes from other tabs
    window.addEventListener("storage", handleStorageChange);

    // Listen for custom events for same-tab changes
    window.addEventListener("debugItemsToggled", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("debugItemsToggled", handleStorageChange);
    };
  }, []);

  return showDebugItems;
};
